"use client"

import { useEffect } from 'react'
import { useSearchParams } from 'next/navigation'

const LOCAL_STORAGE_UTM_KEY = 'fls_utm_data'

export function UtmPersister() {
  const sp = useSearchParams()

  useEffect(() => {
    try {
      if (typeof window === 'undefined') return

      // Достаём UTM из текущего URL
      const maybe = (key: string) => sp.get(key) || undefined
      const urlUtm: Record<string, string | undefined> = {
        utm_source: maybe('utm_source'),
        utm_medium: maybe('utm_medium'),
        utm_campaign: maybe('utm_campaign'),
        utm_content: maybe('utm_content'),
        utm_term: maybe('utm_term'),
        utm_referrer: maybe('utm_referrer'),
        referrer: maybe('referrer'),
        gclid: maybe('gclid'),
        fbclid: maybe('fbclid'),
      }

      // Если параметр utm_referrer/referrer не задан в URL — используем document.referrer при первом заходе
      const docRef = typeof document !== 'undefined' ? (document.referrer || undefined) : undefined
      if (!urlUtm.utm_referrer && docRef) urlUtm.utm_referrer = docRef
      if (!urlUtm.referrer && docRef) urlUtm.referrer = docRef

      // Извлекаем client id из _ga cookie
      const cookieStr = document.cookie || ''
      const gaCookie = cookieStr.split('; ').find(c => c.startsWith('_ga='))
      let gclientid: string | undefined
      if (gaCookie) {
        const value = gaCookie.split('=')[1]
        const parts = value.split('.')
        gclientid = parts.length >= 4 ? `${parts[2]}.${parts[3]}` : value
      }

      // Формируем объект обновлений, исключая undefined/пустые значения,
      // чтобы не перетирать ранее сохранённые UTM при внутренней навигации
      const updates: Record<string, string> = {}
      Object.entries(urlUtm).forEach(([k, v]) => {
        if (typeof v === 'string' && v.trim() !== '') {
          updates[k] = v
        }
      })

      const hasAnyUrlUtm = Object.keys(updates).length > 0 || Boolean(gclientid)
      if (!hasAnyUrlUtm) return

      // Мержим в localStorage под единым ключом
      const prevRaw = localStorage.getItem(LOCAL_STORAGE_UTM_KEY)
      const prev = prevRaw ? JSON.parse(prevRaw) : {}
      const merged = {
        ...prev,
        ...updates,
        ...(gclientid ? { gclientid } : {}),
        saved_at: new Date().toISOString(),
      }
      localStorage.setItem(LOCAL_STORAGE_UTM_KEY, JSON.stringify(merged))
    } catch (err) {
      console.warn('UtmPersister: failed to persist UTM', err)
    }
  }, [sp])

  return null
}